import React from "react";

type HeadingType = {
  children: string;
  tooltip?: string;
};

const Heading = ({ children, tooltip }: HeadingType) => {
  return (
    <div className="flex justify-between items-center mt-4">
      <div className="font-toyotaSemibold border-l-accent border-l-2 text-xl font-semibold px-4 py-1">
        {children}
      </div>
      {tooltip && (
        <div className="tooltip tooltip-left" data-tip={tooltip}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            className="size-8"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
            />
          </svg>
        </div>
      )}
    </div>
  );
};

export default Heading;
